import styled from '@emotion/styled';
import type { ObjectId } from '@racemap/sdk/schema/base';
import { TRACKER_MESSAGE_HISTORY_RECORD_STATE } from '@racemap/sdk/schema/trackers';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { PrimaryButton, WarningButton } from 'src/components/BasicComponents/Buttons';
import { useStore } from '../../../store/reducers';
import type { ManagedTrackerMessages } from '../../../store/trackers/trackers_reducers';
import { IconErase, IconRefresh } from '../../Icon';
import {
  TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND,
  getCurrentMessageStatusCode,
  hasStatusCodeMessages,
  isMessageClosed,
} from './TrackerMessagesTableHelper';
type TrackerMessages = Array<Immutable<ManagedTrackerMessages>>;

interface Props {
  sortedMessages: TrackerMessages;
  trackerId: ObjectId;
}

export const TrackerMessageTableButtonsHeader: FC<Props> = ({ sortedMessages, trackerId }) => {
  const { revokeAllTrackerMessages, clearAllTrackerMessages } = useStore((s) => s.trackers.actions);

  const handleClear = () => {
    clearAllTrackerMessages([trackerId]);
  };

  const handleRevoke = () => {
    revokeAllTrackerMessages([trackerId]);
  };

  const shouldDisableRevokeButton = () => {
    return !sortedMessages.some(
      (message) =>
        getCurrentMessageStatusCode(message) ===
          TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND.PENDING && !isMessageClosed(message),
    );
  };

  return (
    <ButtonGroup>
      <WarningButton
        size="small"
        icon={<IconErase />}
        onClick={() => handleClear()}
        disabled={
          !hasStatusCodeMessages(sortedMessages, TRACKER_MESSAGE_HISTORY_RECORD_STATE.ERROR)
        }
      >
        Clear
      </WarningButton>
      <PrimaryButton
        size="small"
        onClick={() => handleRevoke()}
        icon={<IconRefresh flip="horizontal" fixedWidth />}
        disabled={shouldDisableRevokeButton()}
      >
        Revoke
      </PrimaryButton>
    </ButtonGroup>
  );
};

const ButtonGroup = styled.div`
  position: absolute;
  right: 10px;
  transform: translateY(-50%);
  display: flex;
  gap: 5px;
  background-color: white;
`;
